import { ENDPOINT } from '@old/data/core/endpoints';
import { BACKEND } from '@old/services/core/fetch-backend';
import { transformIntoQueryParamString } from '@old/utils/service';

import { AlertCycleEditionPayload } from './silometrix-alert-cycle-edition.types';

// EL RESPONSE DE ESTE ENDPOINT NO SE UTILIZA, POR LO QUE NO TIENE SENTIDO SER TIPADO
// deprecated service ref.: updateOrganizationData_DEPRECATED
// ✅ Implementado
export async function updateAlertCycleDataService({ query: rawQuery, body }: AlertCycleEditionPayload) {
  const query = transformIntoQueryParamString(rawQuery);

  const { response, data } = await BACKEND.put(ENDPOINT.ORGANIZATIONS, {
    query,
    body,
  });

  return {
    response,
    summary: data,
  };
}
